/**
 * Quantity-mode (MDOT-24700): flags the cash row of a READ-ONLY composition, so the quantity
 * columns render it as the structural row it is — the cash position holds no shares and has
 * no unit price, and both cells show "—" once `isCash` is set.
 *
 * The editor is told which row is cash by `EditorCompositionResponse.cashTicker`.
 * `InvestmentCompositionResponse`, which feeds the portfolio-details composition, carries no
 * such field, so the row is identified by the backend's `CASH_<currency>` ticker instead.
 *
 * Distinct from `pinnedCashRow`, which places an already-flagged cash row in the editor grid.
 * Feature-owned so deleting the quantity feature removes it wholesale.
 */
import type { Instrument } from "../const";

/** Backend cash tickers are `CASH_` followed by the currency code: `CASH_EUR`, `CASH_USD`. */
const CASH_TICKER = /^CASH_/i;

export function isCashTicker(tickerName: string | null | undefined): boolean {
	return tickerName != null && CASH_TICKER.test(tickerName);
}

/** Returns the rows with the cash one flagged; every other row is passed through untouched. */
export function markCashRows(rows: Instrument[]): Instrument[] {
	return rows.map((row) => (isCashTicker(row.tickerName) ? { ...row, isCash: true } : row));
}
